// Lien affilié eBay Partner Network pour trouver un jeu en PHYSIQUE (occasion/boîte).
// Aligné avec la mission : une copie physique = propriété totale, même délistée.
//
// ⚠️ À REMPLIR après inscription à eBay Partner Network (https://partnernetwork.ebay.com) :
//    remplace EBAY_CAMPID par ton vrai Campaign ID. (Idem côté backend : appsettings "Ebay:CampId".)
//    Vérifie aussi le domaine/mkrid dans ton compte EPN si tu cibles un autre pays.
const EBAY_CAMPID = 'YOUR_EBAY_CAMPID';
const EBAY_DOMAIN = 'www.ebay.fr';
const EBAY_MKRID = '709-53476-19255-0'; // France (rotation ID EPN)
const EBAY_CAT = '139973'; // catégorie "Jeux vidéo & consoles" -> évite les résultats hors-jeu

export const ebayPhysicalUrl = (name) => {
  const q = encodeURIComponent(name || '');
  return (
    `https://${EBAY_DOMAIN}/sch/i.html?_nkw=${q}&_sacat=${EBAY_CAT}` +
    `&mkcid=1&mkrid=${EBAY_MKRID}&campid=${EBAY_CAMPID}&toolid=10001&mkevt=1`
  );
};
